import React, { useState, useEffect } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";

import CmtCard from "@coremat/CmtCard";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import { Box, Button } from "@material-ui/core";
import { Assessment } from "@material-ui/icons";
import PointsBankTable from "./PointsBankTable";
import CmtSearch from "@coremat/CmtSearch";
import NewsRequests from "services/news";
import { useDispatch } from "react-redux";
import { baseUrl } from "@jumbo/constants/baseUrl";
import axios from "../../../services/auth/jwt/config";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    [theme.breakpoints.down("xs")]: {
      "& .Cmt-header-root": {
        flexDirection: "column",
      },
      "& .Cmt-action-default-menu": {
        marginLeft: 0,
        marginTop: 10,
      },
    },
  },
  cardContentRoot: {
    padding: 0,
  },
  scrollbarRoot: {
    height: 275,
  },
  actionsContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 20px",
  },
  buttonsContainer: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
  },
}));

const PointsBankContainer = () => {
  const classes = useStyles();
  const [searchVal, setSearchVal] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    if (searchVal) {
      dispatch(NewsRequests.fetchAllPointsBank(1, searchVal));
    } else {
      dispatch(NewsRequests.fetchAllPointsBank(1, ""));
    }
  }, [searchVal]);

  const handleDownload = async () => {
    const downloadUrl = `${baseUrl}pointbank/getall/report`;
    try {
      const response = await axios.get(downloadUrl, {
        responseType: "blob",
      });

      const contentDisposition = response.headers["content-disposition"];
      let filename = "default-filename.xlsx";

      if (contentDisposition) {
        const filenameRegex = /filename\*=UTF-8''([^;]+)/;
        const matches = filenameRegex.exec(contentDisposition);

        if (matches && matches[1]) {
          filename = decodeURIComponent(matches[1]);
        } else {
          const regularFilenameRegex = /filename="([^"]+)"/;
          const regularMatches = regularFilenameRegex.exec(contentDisposition);
          if (regularMatches && regularMatches[1]) {
            filename = regularMatches[1];
          }
        }
      }
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Failed to download the file", error);
    }
  };

  return (
    <CmtCard className={classes.cardRoot}>
      <CmtCardContent className={classes.cardContentRoot}>
        <Box className={classes.actionsContainer}>
          <Box className={classes.buttonsContainer}>
            <Box>
              <CmtSearch
                border={false}
                onlyIcon={false}
                iconPosition="left"
                align="left"
                placeholder="جست و جو"
                value={searchVal}
                onChange={(e) => setSearchVal(e.target.value)}
              />
            </Box>
          </Box>
          <Button
            variant="outlined"
            color="primary"
            startIcon={<Assessment />}
            onClick={handleDownload}
            style={{ marginRight: 14 }}
          >
            دریافت گزارش
          </Button>
        </Box>
        <PointsBankTable searchInput={searchVal} />
      </CmtCardContent>
    </CmtCard>
  );
};

export default PointsBankContainer;
